import { render } from "./StatisticsFilter.vue?vue&type=template&id=578250cd&ts=true"
import script from "./StatisticsFilter.vue?vue&type=script&lang=ts"
export * from "./StatisticsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__